import styled from '@emotion/styled/macro';
import { BaseButton, forDesktopOnly, forPhoneOnly, forTabletLandscapeDown, Variables } from '@enter/core';

export const CompanyButton = styled(BaseButton)`
    /* required props to trigger ellipsis */
    display: block;
    max-width: 300px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    padding: 11px 20px;
    line-height: 18px;
    color: ${Variables.Colors.p500};
    border-radius: ${Variables.Rounded.xlarge};
    height: 40px;
    min-width: auto;

    ${forDesktopOnly(`
        max-width: 450px;
    `)}

    ${forTabletLandscapeDown(`
        max-width: 250px;
    `)}

    ${forPhoneOnly(`
        max-width: 150px;
    `)}
`;
